// extracted by mini-css-extract-plugin
export var alignmentCenter = "inline-text--alignment-center--9b83d";
export var alignmentLeft = "inline-text--alignment-left--63f84";
export var alignmentRight = "inline-text--alignment-right--e945a";
export var emphasisMedium = "inline-text--emphasis-medium--7a41a";
export var emphasisNormal = "inline-text--emphasis-normal--c4eaf";
export var emphasisStrong = "inline-text--emphasis-strong--39a48";
export var inlineText = "inline-text--inline-text--1094d";
export var lineHeightSingleLine = "inline-text--line-height-single-line--dd241";
export var sizeLarge = "inline-text--size-large--70289";
export var sizeMedium = "inline-text--size-medium--94ca6";
export var sizeSmall = "inline-text--size-small--e8cb4";
export var sizeXLarge = "inline-text--size-x-large--e3415";
export var sizeXSmall = "inline-text--size-x-small--d0abb";
export var sizeXxLarge = "inline-text--size-xx-large--b2e13";
export var sizeXxxLarge = "inline-text--size-xxx-large--46b8e";
export var toneDisabled = "inline-text--tone-disabled--7f50c";
export var toneNegative = "inline-text--tone-negative--0accb";
export var toneNeutralDark = "inline-text--tone-neutral-dark--a3964";
export var toneNeutralLight = "inline-text--tone-neutral-light--abf11";
export var tonePositive = "inline-text--tone-positive--99948";
export var toneSubtle = "inline-text--tone-subtle--a4651";
export var toneWarning = "inline-text--tone-warning--9b4cb";